/* eslint-disable no-undef */
import { useCallback, useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import { useDispatch } from "react-redux";
import {
  userLogOut,
  setLoggedStatus,
  setLoggedUsers
} from "../redux/actions/user";

import { playSound } from "../utils/audio";
import { socket } from "../transport";

const disconnected = { status: false, loggedUsers: [] };

const disconnect = () => socket.disconnect();

export default function useSession() {
  const dispatch = useDispatch();

  const { instance } = useMsal();

  const login = () => {
    instance
      .loginRedirect({
        ...loginRequest,
        prompt: "create"
      })
      .catch((error) => console.log(error));

    socket.emit("login", { tenant, "id-token": id_token });
  };

  const logout = () => {
    instance.logoutRedirect().catch((error) => console.log(error));
    dispatch(userLogOut());
    disconnect();
  };

  const isLogged = useCallback(
    (tenant) => {
      socket.emit("isLogged", tenant, (data) => {
        dispatch(setLoggedStatus(data));
        return data?.status;
      });
    },
    [dispatch]
  );

  const isActive = useCallback(
    (body, cb) => socket.emit("isActive", body, (data) => cb(data)),
    []
  );

  useEffect(() => {
    // Keep the socket the listeners were registered on: `socket` is a live
    // binding that initSocket may replace.
    const currentSocket = socket;

    const onDisconnect = (reason) => {
      playSound("ko");
      dispatch(setLoggedStatus({ ...disconnected, reason }));
    };
    const onLogout = () => logout();
    const onLoggedUsers = (logged) => {
      dispatch(setLoggedUsers(logged));
    };

    currentSocket.on("disconnect", onDisconnect);
    currentSocket.on("logout", onLogout);
    currentSocket.on("logged-users", onLoggedUsers);

    // Remove only this hook's listeners: without the cleanup every mount
    // (e.g. Item, remounted at each variant switch) leaked three listeners.
    return () => {
      currentSocket.off("disconnect", onDisconnect);
      currentSocket.off("logout", onLogout);
      currentSocket.off("logged-users", onLoggedUsers);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { logout, login, isLogged, isActive };
}
